import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { Link } from 'formlabs-web-components/Link';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import './DropdownMenu.module.css';

const DropdownMenu = DisplayComponent(
  class DropdownMenu extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        open: false
      };
      this.toggleDropdown = this.toggleDropdown.bind(this);
    }

    toggleDropdown(e) {
      if (!this.dropdownContainerRef.contains(e.target)) {
        this.setState({ open: false });
      } else {
        if (this.dropdownListRef && this.dropdownListRef.contains(e.target)) {
          return;
        } else {
          this.setState({ open: !this.state.open });
        }
      }
    }

    componentDidMount() {
      document.addEventListener('mousedown', this.toggleDropdown, false);
    }
    componentWillUnmount() {
      document.removeEventListener('mousedown', this.toggleDropdown, false);
    }
    render() {
      const { title, items, theme } = this.props;
      const { open } = this.state;
      return (
        <div
          styleName={classnames(
            'dropdown-menu',
            open ? 'open' : 'closed',
            `dropdown_${theme}`
          )}
          tabIndex="0"
          aria-expanded={open}
          role="button"
          aria-label="section navigation"
          ref={container_node => (this.dropdownContainerRef = container_node)}
        >
          <span role="button" styleName="dropdown-button">
            {title}
            {!open && <i className="fl-arrow_drop_down" />}
            {open && <i className="fl-arrow_drop_up" />}
          </span>
          {open && (
            <nav
              styleName="dropdown-items"
              ref={ul_node => (this.dropdownListRef = ul_node)}
            >
              {items.map(item => {
                if (item.link.slice(-1) !== '/') {
                  item.link = item.link + '/';
                }
                return (
                  <Link to={item.link} key={`${item.link}${item.title}`}>
                    <span>{item.title}</span>
                  </Link>
                );
              })}
            </nav>
          )}
        </div>
      );
    }
  }
);

DropdownMenu.propTypes = {};

export default DropdownMenu;
